export default __webpack_public_path__ + "static/media/H4009.d71b8bad.mp3";